
import { createUseStyles } from "react-jss";
import { colors } from "../../../styles/colors";
const useStyles = createUseStyles((_) => ({
  contentMain: {
    overflow: "hidden",
    height: "var(--app-vh)",
    "@media (max-width:899.95px)": {
      overflow: "visible",
      height: "auto",
      minHeight: "var(--app-vh)",
    },
  },
  carIconContainer: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  vehiculeRoot: {
    padding: "20px clamp(16px, 3vw, 30px)",
    height: "var(--app-vh)",
    overflowY: "auto",
    backgroundColor: colors.bgcolor,
    "@media (max-width:899.95px)": {
      paddingTop: "68px",
      height: "auto",
      minHeight: "var(--app-vh)",
      overflowY: "visible",
    },
  },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "30px",
  },
  subContainer: {
    display: "flex",
    flexDirection: "row",
    gap: 15,
    height: "calc(var(--app-vh) - 140px)",
    overflow: "auto",
    "@media (max-width: 1200px)": {
      flexDirection: "column",
      height: "auto",
      overflow: "visible",
    },
  },
  subContainerLeft: {
    display: "flex",
    flexDirection: "column",
    gap: 15,
    "@media (max-width: 1200px)": {
      width: "100%",
    },
  },

  finalItem: {
    display: "flex",
    gap: 15,
    "@media (max-width:899.95px)": {
      flexDirection: "column",
    },
  },
  rightItem: {
    display: "flex",
    flexDirection: "column",
    gap: 15,
    flex: 1,
  },
  subContainerRight: {
    display: "flex",
    flexDirection: "column",
    gap: 15,
    width: "100%",
    minWidth: 0,
    /*
     * Les cartes gardent leur hauteur naturelle ; c'est la colonne qui scrolle.
     *
     * CustomTable est une carte `display:flex` en colonne avec `min-height:0`.
     * Posée ici, dans un parent à hauteur fixe, elle héritait du
     * `flex-shrink:1` par défaut et se faisait comprimer sous la hauteur de
     * son contenu — alors que la zone de tableau porte un `min-height` inline
     * (200px / 228px) et que le pied de carte est en `flex-shrink:0`. Ni l'un
     * ni l'autre ne pouvait céder : le bouton "Voir toutes les interventions"
     * débordait donc hors de sa carte et venait se poser sur le titre de la
     * carte SINISTRES en dessous.
     *
     * On interdit la compression plutôt que de masquer le débordement :
     * `overflow:hidden` sur la carte aurait rendu le pied inaccessible au lieu
     * de le déplacer. Le parent `subContainer` est déjà en `overflow:auto`,
     * donc le surplus de hauteur devient du scroll.
     */
    "& > *": {
      flexShrink: 0,
    },
  },
  containerCar: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    gap: "16px",
    "@media (max-width:599.95px)": {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "12px",
    },
  },
  containerPneumatique: {
    display: "flex",
    flexDirection: "row",
    gap: "15px",
    "@media (max-width:899.95px)": {
      flexDirection: "column",
    },
  },
}));

export default useStyles;
